import { GroupModel, GroupVisibility } from '../types/GroupModel';
import { assertResponse, getJson } from './Utils';

const jsonHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

// The groups the caller can view and add to: Home, their own (incl. My Space), and public groups.
async function getVisible(): Promise<GroupModel[]> {
  const response = await fetch('/api/Groups');
  return await getJson<GroupModel[]>(response);
}

async function create(name: string, visibility: GroupVisibility): Promise<GroupModel> {
  const response = await fetch('/api/Groups', {
    method: 'POST',
    headers: jsonHeaders,
    body: JSON.stringify({ Name: name, Visibility: visibility }),
  });
  return await getJson<GroupModel>(response);
}

async function update(
  id: number,
  changes: { name?: string; visibility?: GroupVisibility },
): Promise<void> {
  const response = await fetch('/api/Groups/' + id, {
    method: 'POST',
    headers: jsonHeaders,
    body: JSON.stringify({ Name: changes.name ?? null, Visibility: changes.visibility ?? null }),
  });
  await assertResponse(response);
}

async function remove(id: number): Promise<void> {
  const response = await fetch('/api/Groups/' + id, { method: 'DELETE' });
  await assertResponse(response);
}

// Copies games into a group as new rows (own id/stars/comments), reusing the shared move graph.
async function copyGames(toGroupId: number, gameIds: number[]): Promise<void> {
  const response = await fetch('/api/Groups/' + toGroupId + '/games/copy', {
    method: 'POST',
    headers: jsonHeaders,
    body: JSON.stringify({ GameIds: gameIds }),
  });
  await assertResponse(response);
}

// Reassigns games from one group to another (both must be yours).
async function moveGames(
  fromGroupId: number,
  toGroupId: number,
  gameIds: number[],
): Promise<void> {
  const response = await fetch('/api/Groups/move', {
    method: 'POST',
    headers: jsonHeaders,
    body: JSON.stringify({ FromGroupId: fromGroupId, ToGroupId: toGroupId, GameIds: gameIds }),
  });
  await assertResponse(response);
}

export default {
  getVisible,
  create,
  update,
  remove,
  copyGames,
  moveGames,
};
